export default __webpack_public_path__ + "static/media/ferramenta-baixar-videos-img8.2b0de08d.jpeg";